module.exports = __webpack_public_path__ + "img/c3d2e76.jpg";